import FieldEditor from "editor/FieldEditor";
import ConfirmModal from "modal/ConfirmModal";
import Gallery from "gallery/Gallery";
import Message from "base/Message";
import {normalizeWheel} from "base/WheelHelper";
import Ajax from "base/Ajax";

$.easing.easeout = (x) => 1 - ( 1 - x ) * ( 1 - x );

class FieldEditorSingleImage extends FieldEditor {
    create() {
        this.$element.addClass("admin-image-editor--active");
        this.addItem = this.addItem.bind(this);
        this.selected = this.$element.is("[data-item]") ? this.$element.attr("data-item") : null;

        this.value = this.$element.attr("data-item");

        this.backgroundPosition = this.$element.is("[data-background-position]") ? this.$element.attr("data-background-position") : "no-repeat center center / cover";

        this.buttonText = this.$element.is("[data-button-text]") ? this.$element.attr("data-button-text") : 'Edit Image';

        this.closeEditor = this.closeEditor.bind(this);
        this.updatePosition = this.updatePosition.bind(this);
        this.editButtonClick = this.editButtonClick.bind(this);

        this.gallery = null;

        if (this.$element.attr("data-gallery")) {
            this.setGallery(new Gallery(this.$element.attr("data-gallery"), '4' /*Single Image Page Field*/));
        } else {
            this.setGallery(new Gallery(null, '4' /*Single Image Page Field*/));
        }
        this.isClearable = this.$element.is("[data-clearable]");
        this.showOverlay = !this.$element.is("[data-no-overlay]");

        this.createEditor();

        const me = this;
        this.$editor.on("click", ".js-add-item", this.addItem).on("click", ".js-edit-item", function () {
            let id = $(this).parents(".js-item").attr("data-item");
            this.selected = null;
            me.gallery.items.forEach((item) => {
                if (item.data.id === id) {
                    let modal = item.getModal();

                    modal.on("okay", () => {
                        item.save();
                    }).on("cancel okay", () => {
                        me.updateContent();
                        if (me.getSelectedImage() === item) {
                            me.setSelectedImage(item.data.id);
                        }
                        modal.destroy();
                        me.emit("closed");
                    });

                    modal.show();
                    return false;
                }
            });
            return false;
        }).on("click", ".js-clear-item", () => {
            this.setSelectedImage(null);
            this.emit("clear");
            return false;
        }).on("click", ".js-remove-item", function () {
            ConfirmModal.confirm('Are you sure you want to remove this image?', undefined, {showLoading: true}).then((done) => {
                let id = $(this).parents(".js-item").attr("data-item");
                let prom = Promise.resolve();
                this.selected = null;
                let item = undefined;
                me.gallery.items.forEach((_item) => {
                    if (_item.data.id === id) {
                        item = _item;
                        item.data.customData.hidden = true;
                        item.changed = true;
                        prom = item.save();
                        return false;
                    }
                });
                prom.then(() => {
                    done();
                    me.updateContent();
                }).catch((e) => {
                    if ("undefined" !== typeof item) {
                        item.data.customData.hidden = false;
                    }
                    new Message(e.message, "Couldn't remove the image");
                    me.updateContent();
                    done();
                })
            });
            return false;
        }).on("click", ".js-item", function () {
            let id = $(this).attr("data-item");
            me.setSelectedImage(id);
            return false;
        }).on("click", ".js-done", () => {
            this.close();
            return false;
        }).on("click", ".js-scroll", function () {
            let origX = me.$items.data("targetScroll") || me.$items.scrollLeft();

            let scrollLeft = Math.max(0, Math.min(me.$items[0].scrollWidth - me.$items.width(), origX + ($(this).attr("data-direction") === "left" ? -300 : 300)));

            me.$items.stop().animate({scrollLeft: scrollLeft}, {
                duration: 300, easing: "easeout", done: () => {
                    me.$items.data("targetScroll", undefined)
                }
            }).data("targetScroll", scrollLeft);
            return false;
        });
        this.$items.on("wheel", (e) => {
            e = e.originalEvent;

            let origX = this.$items.data("targetScroll") || this.$items.scrollLeft();
            let delta = normalizeWheel(e);

            let scrollLeft = Math.max(0, Math.min(this.$items[0].scrollWidth - this.$items.width(), origX + (delta.pixelX !== 0 ? delta.pixelX : delta.pixelY)))

            this.$items.stop().animate({scrollLeft: scrollLeft}, {
                duration: 100, easing: "easeout", done: () => {
                    this.$items.data("targetScroll", undefined)
                }
            }).data("targetScroll", scrollLeft);
            if (origX !== scrollLeft) {
                return false;
            }
        });

        this.$wrap.on("click", ".js-edit-image", this.editButtonClick);

        $(window).on("click", this.closeEditor).on("resize", this.updatePosition);
        window.editor = this;
    }

    setGallery(gallery) {
        if (this.gallery === gallery) return;
        if (this.gallery !== null) {
            this.gallery.destroy();
        }
        this.gallery = gallery;
        this.gallery.on("update", () => this.updateContent()).on("load", () => {
            this.setSelectedImage(this.value);
        }).on("saved", () => {
            this.$element.attr("data-gallery", this.gallery.data.id);
        });

    }

    open() {
        this.justOpened = true;
        setTimeout(() => this.justOpened = false);
        if (this.gallery !== null && !this.gallery.loading && this.gallery.items.length === 0) {
            this.addItem();
            return;
        }
        this.$wrap.addClass("admin-image-editor--shown");
        this.$editor.addClass("admin-single-image--shown");
        this.updatePosition();
        this.emit("show");
    }

    isOpen() {
        return this.$editor.is(".admin-single-image--shown");
    }

    setSelectedImage(id) {
        this.selected = null;
        if (this.gallery !== null) {
            this.gallery.items.forEach((item) => {
                if (item.data.id === id) {
                    let url = item.getImageUrl(this.$element.attr("data-size"));
                    if (this.$element.is("img")) {
                        this.$element.attr("src", url).removeAttr("srcset");
                    } else {
                        if (this.$element.is("[data-image-only]")) {
                            this.$element.css("background-image", "url(" + url + ")");
                        } else {
                            this.$element.css("background", "url(" + url + ") " + this.backgroundPosition);
                        }
                    }
                    this.selected = item.data.id;
                    this.emit("change", item);
                }
            });
        }
        if (this.selected === null) {
            if (this.isClearable) {
                if (this.$element.is("img")) {
                    this.$element.attr("src", "");
                } else {
                    this.$element.css("background", "");
                }
                this.emit("change", null);
                this.$element.attr("data-item", "");
            } else if (this.gallery !== null && this.gallery.items.length > 0) {
                this.setSelectedImage(this.gallery.items[0].data.id);
                return;
            }
        } else {
            this.$element.attr("data-item", id);
        }
        if (['image', 'wrap'].indexOf(this.getPositionTarget()) !== -1) {
            setTimeout(() => this.updatePosition());
        }
        this.updateContent();
    }

    editButtonClick(e) {
        this.open();
        e.preventDefault();
    }

    createEditor() {
        this.$editor = (
            eotwJSXFactory('div', {class: "admin-single-image"}, [
                eotwJSXFactory('div', {class: "admin-single-image__container"}, [
                    eotwJSXFactory('div', {class: "admin-single-image__pointer js-pointer"}),
                    eotwJSXFactory('div', {class: "admin-single-image__arrow admin-single-image__arrow--left js-scroll", 'data-direction': "left"}),
                    eotwJSXFactory('div', {class: "admin-single-image__images js-items-wrap"}, [
                        eotwJSXFactory('div', {class: "admin-loader-wrap admin-loader-wrap--center"}, [
                            eotwJSXFactory('div', {class: "admin-loader"})
                        ])
                    ]),
                    eotwJSXFactory('div', {class: "admin-single-image__arrow js-scroll", 'data-direction': "right"}),
                    eotwJSXFactory('div', {class: "admin-single-image__controls " + (this.isClearable ? "" : "admin-single-image__controls--no-clear")}, [
                        eotwJSXFactory('button', {class: "admin-single-image__btn admin-single-image__btn--upload js-add-item"}, [
                            eotwJSXFactory('span', {class: "admin-single-image__btn-icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'gallery/icons.svg#add-picture"></use></svg>'),
                            "Upload Image"
                        ]),
                        this.isClearable ? eotwJSXFactory('button', {class: "admin-single-image__btn admin-single-image__btn--no-image js-clear-item"}, [
                            eotwJSXFactory('span', {class: "admin-single-image__btn-icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'gallery/icons.svg#no-image"></use></svg>'),
                            "No Image"
                        ]) : undefined,
                        eotwJSXFactory('button', {class: "admin-single-image__btn admin-single-image__btn--done js-done"}, [
                            eotwJSXFactory('span', {class: "admin-single-image__btn-icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'gallery/icons.svg#selected"></use></svg>'),
                            "Done"
                        ])
                    ])
                ])
            ])
        );
        this.$items = this.$editor.find(".js-items-wrap");

        if (this.$element.is("img")) {
            this.$wrap = (
                eotwJSXFactory('div', {class: "admin-image-editor admin-image-editor--wrap admin-image-editor--active"})
            );
            this.$element.before(this.$wrap);
            this.$wrap.append(this.$element);
        } else {
            this.$wrap = this.$element;
        }

        this.customOverlay = false;

        if (this.showOverlay) {
            if (this.$element.find(".admin-image-editor__overlay").length > 0) {
                this.customOverlay = true;
                this.$overlay = this.$element.find(".admin-image-editor__overlay");
            } else {
                this.$overlay = (
                    eotwJSXFactory('div', {class: "admin-image-editor__overlay " + (this.$element.is("[data-overlay]") ? this.$element.attr("data-overlay").split(" ").map((clazz) => "admin-image-editor__overlay--" + clazz).join(" ") : "")}, [
                        eotwJSXFactory('div', {class: "admin-image-editor__btn-wrap"}, [
                            eotwJSXFactory('button', {class: "admin-image-editor__btn js-edit-image"}, [
                                eotwJSXFactory('span', {class: "admin-image-editor__btn-icon"}),
                                this.buttonText
                            ])
                        ])
                    ])
                );
                this.$wrap.append(this.$overlay);
            }
        } else {
            this.$overlay = $([]);
        }

        if (this.$element.parents(".admin-modal-wrap").length > 0) {
            $(".admin-modal-wrap").append(this.$editor);
        } else {
            $("body").append(this.$editor);
        }
        this.updatePosition();
    }

    addItem() {
        if (this.gallery === null) {
            console.debug('Tried to addItem before the gallery was loaded')
        }
        this.emit("opened");
        this.close();
        this.gallery.showAddImage().then(() => {
            // Automatically save the gallery
            this.gallery.save();
            if (this.selected === null) {
                this.setSelectedImage(this.gallery.items[this.gallery.items.length - 1].data.id);
            }
            this.emit("closed");
            if (this.gallery.items.length > 0) {
                this.open();
            }
        }).catch(() => {
            this.emit("closed");
            if (this.gallery.items.length > 0) {
                this.open();
            }
        });
    }

    getPositionTarget() {
        if (this.$element.is("[data-target]")) {
            return this.$element.attr("data-target");
        } else {
            return 'wrap';
        }
    }

    getPositionTargetElement() {
        let target = this.getPositionTarget();

        if (target === 'wrap') {
            return this.$wrap;
        } else if (target === 'button') {
            return this.$overlay.find(".js-edit-image");
        } else if (target === 'image') {
            return this.$element;
        } else {
            return $(target);
        }
    }

    updatePosition() {
        let $target = this.getPositionTargetElement();

        if (!$target) return;

        let offset = $target.offset();

        if (!$target.is(":visible") || "undefined" === typeof offset) {
            return;
        }

        let top;
        let left;

        let editorWidth = this.$editor.children().width();

        let isModalEditor = this.$element.parents(".admin-modal-wrap").length > 0;

        top = (offset.top - (isModalEditor ? $("body").scrollTop() : $("body").offset().top) + 10) + $target.outerHeight();
        left = offset.left + ($target.outerWidth() / 2);

        let center = true;

        if (left < editorWidth / 2) {
            left = (editorWidth / 2) + 10;
            center = false;
        } else if (left + ( editorWidth / 2) > $(window).width()) {
            left = $(window).width() - ( editorWidth / 2) - 10;
            center = false;
        }

        this.$editor.css({
            top: top,
            left: left
        });

        let pointerLeft;

        if (center) {
            pointerLeft = (this.$editor.children().width() / 2) - (this.$editor.find(".js-pointer").width() / 2);
        } else {
            pointerLeft = ($target.offset().left + $target.width() / 2) - (this.$editor.find(".js-pointer").width() / 2) - this.$editor.children().offset().left;
        }

        pointerLeft = Math.max(36, Math.min(502, pointerLeft));
        this.$editor.find(".js-pointer").css("left", pointerLeft);
    }

    close() {
        this.$editor.removeClass("admin-single-image--shown");
        this.$wrap.removeClass("admin-image-editor--shown");
        this.emit("close");
    }

    closeEditor(e) {
        if (this.justOpened || !this.$wrap.is(".admin-image-editor--shown")) return;
        let $target = $(e.target);
        let excludes = [
            this.$editor,
            this.$wrap,
            $('.admin-modal--shown')
        ];

        let valid = true;
        let $parents = $target.parents().get();

        excludes.forEach(($el) => {
            valid = valid && !$target.is($el) && $parents.indexOf($el[0]) === -1;
        });

        if (valid) {
            this.close();
            return false;
        }
    }

    updateContent() {
        if (this.gallery === null || this.gallery.loading) {
            this.$items.html(
                eotwJSXFactory('div', {class: "admin-loader-wrap admin-loader-wrap--center"}, [
                    eotwJSXFactory('div', {class: "admin-loader"})
                ])
            )
        } else {
            this.$items.html(
                this.gallery.items.map((item) => item.data.id !== this.selected && item.data.customData.hidden ? [] : (
                    eotwJSXFactory('div', {class: "js-item admin-single-image__image " + (item.data.id === this.selected ? "admin-single-image__image--selected" : ""), 'data-item': item.data.id, style: "background: url(" + item.getImageUrl('6') + ") no-repeat center center / cover;"}, [
                        eotwJSXFactory('div', {class: "admin-gallery__item__buttons"}, [
                            eotwJSXFactory('button', {class: "admin-gallery__Hbtn admin-gallery__Hbtn--edit js-edit-item"}, [
                                eotwJSXFactory('span', {class: "admin-gallery__Hbtn__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'gallery/icons.svg#edit-icon"></use></svg>'),
                                "Edit"
                            ]),
                            !item.data.customData.hidden && item.data.id !== this.selected ? eotwJSXFactory('button', {class: "admin-gallery__Hbtn admin-gallery__Hbtn--remove js-remove-item"}, [
                                eotwJSXFactory('span', {class: "admin-gallery__Hbtn__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'base/icons.svg#close"></use></svg>')
                            ]) : undefined
                        ])
                    ])
                )).reverse()
            );
        }
    }


    destroy() {
        super.destroy();

        this.$element.removeClass("admin-image-editor--active admin-image-editor--shown");
        this.$editor.remove();

        if (this.$element.is("img")) {
            this.$wrap.before(this.$element);
            this.$wrap.remove();
        }

        if (!this.customOverlay) {
            this.$overlay.remove();
        } else {
            this.$wrap.off("click", ".js-edit-image", this.editButtonClick);
        }

        $(window).off("click", this.closeEditor).off("resize", this.updatePosition);

        this.$editor = null;
        this.$wrap = null;

        if (this.gallery !== null) {
            this.gallery.destroy();
            this.gallery = null;
        }
    }

    getSelectedImage() {
        let id = this.getValue();
        if (id === '') return null;

        let image = null;
        if (this.gallery !== null) {
            this.gallery.items.forEach((_image) => {
                if (_image.data.id === id) {
                    image = _image;
                    return false;
                }
            });
        }
        return image;
    }

    getValue() {
        return this.selected !== null ? this.selected : ''
    }

    setValue(value) {
        if (value !== null && "object" === typeof value) {
            this.value = value.id;
        } else {
            this.value = value;
        }

        if (this.value !== null) {
            if (this.gallery === null || this.gallery.items.map((item) => item.data.id).indexOf(this.value) === -1) {
                this.gallery = null;
                this.updateContent();

                Ajax.get('gallery', 'items/' + this.value).then((item) => {
                    this.setGallery(new Gallery(item.gallery.id, '4' /*Single Image Page Field*/));
                }).catch((e) => {
                    this.setGallery(new Gallery(null, '4' /*Single Image Page Field*/));
                });
            } else {
                this.setSelectedImage(this.value);
            }
        } else {
            this.setSelectedImage(null);
        }
    }
}


export default FieldEditorSingleImage;
